import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';
import { Button } from '..';

import styles from './slide-toggle.module.scss';

const SlideToggle = ({
  id,
  onToggle,
  option1,
  option2,
  option1Label,
  option2Label,
  value,
  disabled,
  ...props
}) => {
  return (
    <div
      id={id}
      className={cn(
        styles.slideToggle,
        // eslint-disable-next-line react/prop-types
        props.className,
        applyClasses(props, styles)
      )}
      {...applyProps(props)}
    >
      <Button
        id={id && `${id}_1`}
        className={cn(styles.option, { [styles.selected]: option1 === value })}
        onClick={() => option1 !== value && onToggle?.()}
        disabled={disabled}
        aria-pressed={option1 === value}
      >
        {option1Label || option1}
      </Button>
      <Button
        id={id && `${id}_2`}
        className={cn(styles.option, { [styles.selected]: option2 === value })}
        onClick={() => option2 !== value && onToggle?.()}
        disabled={disabled}
        aria-pressed={option2 === value}
      >
        {option2Label || option2}
      </Button>
      <div
        className={cn(styles.indicator, {
          [styles.leftSelected]: option1 === value,
          [styles.rightSelected]: option2 === value,
        })}
      />
    </div>
  );
};

SlideToggle.propTypes = {
  /** The ID of the toggle element. Useful to select the toggle during testing. Also used as a prefix for the buttons in the toggle */
  id: PropTypes.string,
  /** Function to run when the unselected option is selected */
  onToggle: PropTypes.func,
  /** Value/ default Label for the first option */
  option1: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** Value/ default Label for the second option */
  option2: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** Label override for the first option could be string or ReactComponent */
  option1Label: PropTypes.any,
  /** Label override for the second option could be string or ReactComponent */
  option2Label: PropTypes.any,
  /** The current value of the toggle */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /** Sets the disabled property on the slide toggle */
  disabled: PropTypes.bool,
};

SlideToggle.defaultProps = {
  onToggle: undefined,
  option1: undefined,
  option2: undefined,
  value: undefined,
  disabled: undefined,
};

export default SlideToggle;
